<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <province-create-or-update v-model="province" :errors="errors"></province-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    :add-callback="createNew"
                    :buttons="buttons"
                    search
                    pagination="server"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import SystemDataApi from '@/api/system-data'
import ProvinceCreateOrUpdate from './components/ProvinceCreateOrUpdate.vue';

export default {
    components:{
        BCard,
        ProvinceCreateOrUpdate
    },
    data(){
        return {
            fields:[
                {name:'Ülke',key:'CountryName',thClass:'w-25'},
                {name:'Bölge',key:'RegionName',thClass:'w-25'},
                {name:'İl',key:'Name',thClass:'w-25'},
                {name:'Endeks',key:'Index'},
                {name:'Endeks Kategorisi',key:'ProvinceIndexCategoryName',thClass:'w-25'},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            province:{
                Id:null,
                Name: null,
                CountryId: null,
                RegionId: null,
                X_Coordinate: null,
                Y_Coordinate: null,
                Index:null,
                ProvinceIndexCategoryId:null
            },
            errors:{},
            editing: false,
            loading: false
        }
    },
    methods:{
        provider(data){
            return SystemDataApi.ProvinceOperations.Table(data)
        },
        clearForm(){
            this.editing = false
            this.province.Id = null
            this.province.Name = null
            this.province.CountryId = null
            this.province.RegionId = null
            this.province.X_Coordinate = null
            this.province.Y_Coordinate = null
            this.province.Index = null
            this.province.ProvinceIndexCategoryId = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.province.Id = item.Id
            this.province.Name = item.Name
            this.province.CountryId = item.CountryId
            this.province.RegionId = item.RegionId
            this.province.X_Coordinate = item.X_Coordinate
            this.province.Y_Coordinate = item.Y_Coordinate
            this.province.Index = item.Index
            this.province.ProvinceIndexCategoryId = item.ProvinceIndexCategoryId
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            SystemDataApi.ProvinceOperations.CreateOrUpdate(this.editing,this.province)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
            .catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} isimli il bilgisini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    SystemDataApi.ProvinceOperations.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>